export const barStories = [
    {
        label: 'Using markers',
        link: {
            kind: 'Bar',
            story: 'with marker',
        },
    },
    {
        label: 'Stacked diverging bar chart',
        link: {
            kind: 'Bar',
            story: 'diverging stacked',
        },
    },
    {
        label: 'Grouped diverging bar chart',
        link: {
            kind: 'Bar',
            story: 'diverging grouped',
        },
    },
    {
        label: 'Custom bar element',
        link: {
            kind: 'Bar',
            story: 'custom bar item',
        },
    },
    {
        label: 'Formatting values',
        link: {
            kind: 'Bar',
            story: 'with formatted values',
        },
    },
    {
        label: 'Using custom tooltip',
        link: {
            kind: 'Bar',
            story: 'custom tooltip',
        },
    },
    {
        label: 'Custom axis ticks',
        link: {
            kind: 'Bar',
            story: 'custom axis ticks',
        },
    },
]
